import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FaQuoteLeft, FaAward, FaIndustry } from "react-icons/fa";
import finalBanner from "../assets/finalbanner.png";
import "../pages/About.css";
import "./CEODetails.css";

const CEODetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">

      {/* HERO */}
     <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
   MR. S.SHANKAR
   <p className="hero-subtitle">Founder & CEO — Flowtech Pumps & Motors</p>
</motion.h1>

  </div>
</section>

      {/* PROFILE CARD */}
      <section className="ceo-hero-card">
        <div className="container ceo-hero-inner">
          <div className="ceo-avatar-xl">S</div>
          <div>
            <h2>33 Years of Engineering Leadership</h2>
            <p>
              Visionary behind Flowwell Pumps & Meters and Flowtech Pumps & Motors,
              driving reliability in India’s critical infrastructure.
            </p>
          </div>
        </div>
      </section>

      {/* QUOTE */}
      <section className="ceo-quote">
        <FaQuoteLeft />
        <p>
          “Engineering is not just about moving fluids; it’s about reliability that
          powers nations.”
        </p>
      </section>

      {/* CONTENT */}
      <section className="section-padding">
        <div className="container ceo-unique-grid">

          {/* LEFT – STORY */}
        <ul className="journey-list">
  <li>
    Mr. S SHANKAR, CEO, with 33 Years’ Experience (25 Years – as a Co-founder
    in Flowwell Pumps & Meters, looked after entire manufacturing activities
    & earlier to that 7 Years – worked for Best & Crompton Engineering Ltd,
    Chennai & Bangalore).
  </li>

  <li>
    During 25 Years tenure at Flowwell – Mr S Shankar contributed his service
    and obtained approval from major customers – BHEL, ABB, ALSTOM, PGCIL,
    NTPC, NPCIL, Indian Railways (ICF, RCF, CLW) & Indian Navy for Sea Water
    Application Pumps.
  </li>

  <li>
    During Mr. Shankar tenure at Flowwell, contributed towards building the
    organisation holistically, setting up high quality standards, with
    professional technical abilities in production.
  </li>

  <li>
    He Contributed and developed Traction Pumps for Global customer’s like.ABB Geneva,
    Siemens Nurnberg, JST France, Bombardier Transportation.
  </li>

  <li>
    He initiated and obtained ISO 9001:2000 certificate during 2003 and obtained
    upgraded version of ISO 9001:2008. Latest version of ISO 9001:2015 also certified.
  </li>
</ul>


          {/* RIGHT – IMPACT */}
          <div className="ceo-impact-box">
            <h4>Strategic Impact</h4>

            <ul>
              <li>
                <FaIndustry />
                Approved supplier for BHEL, ABB, ALSTOM, PGCIL, NTPC, NPCIL
              </li>
              <li>
                <FaIndustry />
                Indian Railways (ICF, RCF, CLW, DLW, DMW)
              </li>
              <li>
                <FaIndustry />
                Indian Navy – Sea Water Application Pumps
              </li>
              <li>
                <FaIndustry />
                Global traction pump development for ABB Geneva, Siemens Nürnberg,
                JST France, Bombardier Transportation
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CERTIFICATIONS & AWARDS */}
      <section className="ceo-awards-strip">
        <div className="container">
          <div className="award-card">
            <FaAward />
            <h5>National Industrial Excellence Award</h5>
            <span>2007</span>
          </div>
          <div className="award-card">
            <FaAward />
            <h5>Pride of India Award</h5>
            <span>2008</span>
          </div>
          <div className="award-card">
            <FaAward />
            <h5>ISO 9001 Certified</h5>
            <span>2000 → 2015</span>
          </div>
        </div>
      </section>

      {/* FINAL DETAILS */}
    <section className="section-padding">
  <div className="container">
    <ul className="journey-list">
      <li>
        The total strength of the company is 60 and this includes skilled workers,
        qualified supervisory staff. Production department work hand in hand to make
        sure that FLOWTECH PUMPS AND MOTORS turns out the best quality product in the market
      </li>

      <li>
        The company has obtained ISO 9001:2015 Certification of the quality
        Management System applicable to Design, manufacture, supply and servicing
        of Transformer oil pumps of capacity 0.2K to 10 K LPM and centrifugal Pumps
        of Discharge Capacity 1 to 160 TPH.
      </li>

      <li>
        FLOWTECH PUMPS AND MOTORS manufactures- Centrifugal, Axial flow (inline) and
        Centrifugal Inline Models 11, 12 and 15 series and of different capacities.
        Sea Water pump for marine application used by Navy, Water pump to RDSO
        Specification. OIL Pump to ICF, RCF and Railways. We have taken up Export orders
        for supply of Transformer Oil Pumps to firms like ABB, Siemens Germany, France
        & JST – France
      </li>
    </ul>
  </div>
</section>

    </div>
  );
};

export default CEODetails;
